import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class ProjectsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
              args: args, 
              projects: []  
        }
    }  
    
    async componentDidMount() {
        BaseApi.get('/project/projects', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.setState({projects: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openProject(id) {
        this.props.navigate("project", {caller: "projects", callargs: this.state.args, project: id})
    }

    renderProject(project) {
        return (
            <tr
                id = {project.id}
                className="table-row-clickable"
                onClick={()=>this.openProject(project.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {project.name}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {project.description}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {project.donor}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {project.organization}
                </td>
                <td class="text-start p-1" style={{ whiteSpace: 'nowrap' }}>
                    {project.start}
                </td>
                <td class="text-start p-1" style={{ whiteSpace: 'nowrap' }}>
                    {project.end}
                </td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Проекты"}/>
                 <div className="row mt-4 mb-3">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7 d-flex align-items-start justify-content-end mt-3 mt-lg-0">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            onClick={() => this.openProject("")}
                        >
                            Добавить проект
                        </button>
                    </div>
                 </div>
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="nameCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Наименование
                                        </th>
                                        <th id="descriptionCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Описание
                                        </th>
                                        <th id="donorCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Финансировниае
                                        </th>
                                        <th id="organizationCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Организация
                                        </th>
                                        <th id="startCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Начало
                                        </th>
                                        <th id="endCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Окончание
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.projects.map((value, index) => this.renderProject(value))}
                                </tbody>
                            </table>      
                        </div>
                    </div>
                </div>        
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/projects.js